import React from "react";
export default class View_Rank extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      spinner: false,
      listrank: [],
    };

  

    // Vinculo entre que força atualização entre os filhos, este componente, e o props.Jogo
    this.update = this.update.bind(this);

    this.props.serve.ancora(this.update);
    
  }


  componentDidMount(){
    this.setState({
      listrank: []
    });
    this.props.serve.rank()

  }

  componentWillUnmount(){
    this.setState({
      listrank: []
    });
  }



  update(rank) {
    this.setState({
      listrank: rank
    });
  }

    composicaoRank(){
      var users = [];
      if(this.props.auth.usuario !== null)
        for (let index = 0; index < this.state.listrank.length; index++) {
          if(this.state.listrank[index].key === this.props.auth.usuario.user.uid)
            if(index +1 >= 6)
            users.push( (
              <tr key={index} className="table-primary">
                <th scope="row">{this.state.listrank[index].posicao}</th>
                <td>{this.state.listrank[index].nick}</td>
                <td>{this.state.listrank[index].pontuacao}</td>
                <td>{this.state.listrank[index].tempo.minutes} : {this.state.listrank[index].tempo.seconds}</td>
                <td>{(new Date(this.state.listrank[index].ultimoAcesso)).toLocaleString("pt-BR")}</td>
              </tr>)); 
              

            else
            users.push( (
                <tr key={index} className="table-primary">
                  <th scope="row">{index +1}</th>
                  <td>{this.state.listrank[index].nick}</td>
                  <td>{this.state.listrank[index].pontuacao}</td>
                  <td>{this.state.listrank[index].tempo.minutes} : {this.state.listrank[index].tempo.seconds}</td>
                  <td>{(new Date(this.state.listrank[index].ultimoAcesso)).toLocaleString("pt-BR")}</td>
                </tr>)); 

            


          else users.push( (
            <tr key={index}>
              <th scope="row">{index+1}</th>
              <td>{this.state.listrank[index].nick}</td>
              <td>{this.state.listrank[index].pontuacao}</td>
              <td>{this.state.listrank[index].tempo.minutes} : {this.state.listrank[index].tempo.seconds}</td>
              <td>{(new Date(this.state.listrank[index].ultimoAcesso)).toLocaleString("pt-BR")}</td>
            </tr>
          ));
        }

      else 
      for (let index = 0; index < this.state.listrank.length; index++) {
        users.push( (
          <tr key={index}>
            <th scope="row">{index +1}</th>
            <td>{this.state.listrank[index].nick}</td>
            <td>{this.state.listrank[index].pontuacao}</td>
            <td>{this.state.listrank[index].tempo.minutes} : {this.state.listrank[index].tempo.seconds}</td>
            <td>{(new Date(this.state.listrank[index].ultimoAcesso)).toLocaleString("pt-BR")}</td>
          </tr>
        ));
      }


      return React.createElement('tbody', { }, users);

    }
    render() {
    return (
  
      <div className="col d-flex flex-column align-items-center  text-center w-100 h-100 p-md-5 p-3">
        <h1>Placar de Jogadores</h1>
        <table className="table table-dark table-hover">
        <thead>
            <tr>
            <th scope="col">#</th>
            <th scope="col">Nickname</th>
            <th scope="col">Pontuação</th>
            <th scope="col">Tempo</th>
            <th scope="col">Último Acesso</th>
            </tr>
        </thead>
        {this.composicaoRank()}
        </table>
  
      </div>
    );
  }

}